import {Injectable} from '@angular/core';
import {BdbSessionStrgService} from '@npm-bbta/bbog-cm-auth-lib';
import {SessionStorageKeysEnum} from '../models/session-storage-keys-enum';

declare var dataLayer: Array<any>;

@Injectable()
export class GoogleTagManagerService {

    constructor(
        private sessionStorageService: BdbSessionStrgService
    ) {
    }

    sendInfo(pagePath: string, pageName: string, additionalParameters?: any) {
        console.log('Pushing: ' + pagePath);
        let parameters = {
            'screenPath': pagePath,
            'screenName': pageName,
            'customerChannel': this.getOfficeType(),
            'customerType': this.getCustomerState(),
            'productType': this.getProductType(),
            'officeId': this.sessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE),
            'requestId': 'pendienteRequestId',
            'photo_provider': this.getPhotoProvider()
        };
        if (additionalParameters) {
            parameters = {...parameters, ...additionalParameters};
        }
        dataLayer.push(parameters)
        dataLayer.push({event: 'appScreenView'});
    }

    public sendError(friendlyErrorPageName: string): void {
        const errorCode = this.sessionStorageService.get(SessionStorageKeysEnum.ERROR_CODE);
        this.sendInfo('/error', friendlyErrorPageName, {errorCode});
    }

    private getProductType() {
        const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
        if (site === '1') {
            return 'CA';
        } else if (site === '3') {
            return 'TC';
        } else if (site === '5') {
            return 'CV';
        } else if (site === '7' || site === '8') {
            return 'CL';
        } else if (site === '10') {
            return 'LD'
        } else if (site === '11') {
            return 'PV'
        } else if (site === '12') {
            return 'MTZ'
        } else if (site === '16') {
            return 'SG'
        } else if (site === '17') {
            return 'CDT'
        } else if (site === '36') {
            return 'CC'
        } else if (site === '40') {
            return 'VH'
        } else if (site === '42') {
            return 'LD'
        } else if (site === '43') {
            return 'FDB'
        }else {
            console.log('site not set');
            return 'XX';
        }
    }

    private getCustomerState() {
        const customerState = this.sessionStorageService.get(SessionStorageKeysEnum.CUSTOMER_STATE);
        if (customerState === 'ACTIVE') {
            return 'A';
        } else if (customerState === 'NOT_CLIENT') {
            return 'N';
        } else if (customerState === 'LEAD') {
            return 'L';
        }
        return 'X';
    }
    private getOfficeType() {
        const officeType = this.sessionStorageService.get('mediumType');
        if (officeType === '1') {
            return 'A';
        } else if (officeType === '2') {
            return 'F';
        } else if (officeType === '3') {
            return 'FM';
        } else if (officeType === '4') {
            return 'O';
        } else if (officeType === '6') {
            return 'MFZ';
        } else {
            console.log('mediumType not found');
            return 'X';
        }
    }

    private getPhotoProvider(): string {
        const photoProvider = this.sessionStorageService.get('photoProvider');
        return photoProvider ? photoProvider : 'X';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/google-tag-manager.service.ts